module.exports = __webpack_public_path__ + "static/media/usecase-card-4-icon.4e54f812.svg";